var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1814108_email_envenlope_letter_mail_icon 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Envelope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M24.2811 8.22505L23.4498 7.3938L15.7498 15.0938C14.7873 16.0563 13.1686 16.0563 12.2061 15.0938L4.50606 7.43755L3.6748 8.2688L9.40605 14.0001L3.6748 19.7313L4.50606 20.5626L10.2373 14.8313L11.3748 15.9688C12.0748 16.6688 12.9936 17.0626 13.9561 17.0626C14.9186 17.0626 15.8373 16.6688 16.5373 15.9688L17.6748 14.8313L23.4061 20.5626L24.2373 19.7313L18.5061 14.0001L24.2811 8.22505Z",
    fill: "#134563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M22.6627 22.0501H5.38145C4.3752 22.0501 3.54395 21.2188 3.54395 20.2126V7.8751C3.54395 6.86885 4.3752 6.0376 5.38145 6.0376H22.6627C23.6689 6.0376 24.5002 6.86885 24.5002 7.8751V20.2126C24.5002 21.2188 23.6689 22.0501 22.6627 22.0501ZM5.33769 7.21885C4.98769 7.21885 4.7252 7.48134 4.7252 7.83134V20.1688C4.7252 20.5188 4.98769 20.7813 5.33769 20.7813H22.6189C22.9689 20.7813 23.2314 20.5188 23.2314 20.1688V7.83134C23.2314 7.48134 22.9689 7.21885 22.6189 7.21885H5.33769Z",
    fill: "#134563"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.29a2bce0e7fa42ac30b71f62c770078f.svg";
export { ForwardRef as ReactComponent };